import { ThemeTypes } from 'src/themes';
import { AppSubdomains } from 'src/types/common';

type LayoutConfig = {
  headerBrand: boolean;
  headerAddress: boolean;
  navigation: boolean;
  searchBar: boolean;
  cartLinkButton: boolean;
  supportButton: boolean;
  layoutTimer: boolean;
  mobileHeaderBrand: boolean;
  discountCoupons: boolean;
  showAddressName: boolean;
};

type ThemeLayoutConfig = {
  [key in AppSubdomains]: {
    defaultLayout: LayoutConfig;
  };
};

const DEFAULT_CONFIG = {
  defaultLayout: {
    headerBrand: true,
    headerAddress: true,
    navigation: true,
    searchBar: true,
    cartLinkButton: true,
    supportButton: true,
    layoutTimer: false,
    mobileHeaderBrand: false,
    discountCoupons: true,
    showAddressName: true,
  },
};

export const layoutConfig: ThemeLayoutConfig = {
  [ThemeTypes.Homebar]: {
    defaultLayout: {
      ...DEFAULT_CONFIG.defaultLayout,
      supportButton: true,
      discountCoupons: false,
    },
  },
  [ThemeTypes.Terea]: {
    defaultLayout: {
      ...DEFAULT_CONFIG.defaultLayout,
      navigation: false,
      searchBar: false,
      supportButton: false,
      layoutTimer: true,
      mobileHeaderBrand: true,
      discountCoupons: false,
      showAddressName: false,
    },
  },
  [ThemeTypes.Pari]: {
    defaultLayout: DEFAULT_CONFIG.defaultLayout,
  },
};
